// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyBBga-O7NP0WhJQmw9VNLFD3-G5pGawIw4",
  authDomain: "gfg-nmm.firebaseapp.com",
  projectId: "gfg-nmm",
  storageBucket: "gfg-nmm.firebasestorage.app",
  messagingSenderId: "1051540743046",
  appId: "1:1051540743046:web:ea59cbc44f5ca7ae744207",
  measurementId: "G-5PEN67BYT8"
};


// const firebaseConfig = {
//   apiKey: "AIzaSyBl6ymInIrH7j4_3F9Rl2grjVHtacb4P4Q",
//   authDomain: "fir-404db.firebaseapp.com",
//   databaseURL: "https://fir-404db-default-rtdb.firebaseio.com",
//   projectId: "fir-404db",
//   storageBucket: "fir-404db.firebasestorage.app",
//   messagingSenderId: "968860668024",
//   appId: "1:968860668024:web:7a38e6fd9cdd1afd98dd8d",
//   measurementId: "G-BQEX5RJ4TE"
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const db = getFirestore(app);
const messaging = getMessaging(app);
export { db,messaging, getToken, onMessage };
